import { render, staticRenderFns } from "./Ways.vue?vue&type=template&id=3410e5ca&scoped=true&"
import script from "./Ways.vue?vue&type=script&lang=js&"
export * from "./Ways.vue?vue&type=script&lang=js&"
import style0 from "./Ways.vue?vue&type=style&index=0&id=3410e5ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3410e5ca",
  null
  
)

export default component.exports